import React, { useContext, useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { ResponsiveContext } from '../../contexts/ResponsiveContext.js';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { ServerContext } from '../../contexts/ServerContext.js';
import nexark_preview2 from '../../assets/nexark-preview2.webp';
import nexark_preview3 from '../../assets/nexark-preview3.webp';
import 'swiper/css/navigation';
import 'swiper/css';
import './livepage.scss';

const baseURL = 'https://www.nexark.de/proxy.php';

const TwitchEmbed = React.memo(({ user_login, muted }) => {
  const parentDomain = window.location.hostname;

  return (
    <div className="twitch-embed">
      <iframe
        src={`https://player.twitch.tv/?channel=${user_login}&parent=${parentDomain}${muted ? "&muted=true" : ""}`}
        height="100%"
        width="75%"
        allowFullScreen
        title={user_login}
      ></iframe>
      <iframe
        src={`https://www.twitch.tv/embed/${user_login}/chat?parent=${parentDomain}&darkpopout`}
        height="100%"
        width="25%"
        title={`Chat von ${user_login}`}
      />
    </div>
  );
}, (prevProps, nextProps) => 
  prevProps.user_login === nextProps.user_login && prevProps.muted === nextProps.muted
);

const Livepage = () => {
  const [liveStreams, setLiveStreams] = useState([]);
  const [allChannels, setAllChannels] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [streamers, setStreamers] = useState([]);
	const { servers, serverInfos, serverPlayers,} = useContext(ServerContext);

  const { phoneView } = useContext(ResponsiveContext);

	useEffect(() => {
		console.log("Servers from context:", servers);
		console.log("Server Infos from context:", serverInfos);
		console.log("Server Players from context:", serverPlayers);
	}, [servers, serverInfos, serverPlayers]);

  useEffect(() => {
    fetch(`${baseURL}?mode=twitch_streamers`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          setStreamers(data);
        }
      })
      .catch(console.error);
  }, []);

	const fetchLiveStreams = useCallback(() => {
		fetch(`${baseURL}?mode=twitch_search_streamers`)
			.then(res => res.json())
			.then(data => {
				console.log("Streams fetched:", data);
				
				const sortedStreams = (data || []).slice().sort((a, b) => b.viewer_count - a.viewer_count);

				setLiveStreams(prev => {
					const isSame = prev.length === sortedStreams.length &&
						prev.every((s, i) =>
							s.user_login === sortedStreams[i].user_login &&
							s.viewer_count === sortedStreams[i].viewer_count
						);

					if (isSame) return prev;

					return sortedStreams;
				});
			})
			.catch(console.error);
	}, []);

  useEffect(() => {
    if (streamers.length === 0) return;

    fetchLiveStreams();

    fetch(`${baseURL}?mode=twitch_channels&channels=${streamers.join(',')}`)
      .then(res => res.json())
      .then(data => {
        const sorted = (data.data || []).sort((a, b) => a.display_name.localeCompare(b.display_name));
        setAllChannels(sorted);
      })
      .catch(console.error);
  }, [streamers, fetchLiveStreams]);

  useEffect(() => {
    if (streamers.length === 0) return;

    const interval = setInterval(fetchLiveStreams, 30000);
    return () => clearInterval(interval);
  }, [streamers, fetchLiveStreams]);

  return (
    <div className='main-wrapper livepage-wrapper'>
      {!phoneView && (
        <>
          <div className='title-wrapper'>
            <h3 className='title'><i className="bi bi-camera-video"></i> Streamer die bei uns spielen</h3>
            <hr />
          </div>
          <div className='stream-section'>
            {liveStreams.length > 0 ? (
              <Swiper
                spaceBetween={30}
                slidesPerView={1}
                navigation
                modules={[Navigation]}
                loop
                onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
                initialSlide={0}
              >
                {liveStreams.map((stream, idx) => (
                  <SwiperSlide key={stream.user_login}>
                    <TwitchEmbed user_login={stream.user_login} muted={idx !== activeIndex} />
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <div className='no-streams-live'>
                <h2>Keine Streamer live auf NEXARK</h2>
                <img src={nexark_preview3} alt="" />
              </div>
            )}
          </div>
        </>
      )}

      <div className='title-wrapper'>
        <h3 className='title'><i className="bi bi-camera-video-off"></i> All unsere Streamer</h3>
        <hr />
      </div>
      <div className="streamer-grid" style={{ justifyContent: phoneView ? "flex-start" : "center" }}>
        {allChannels.map(channel => (
          <Link
            className="streamer-card"
            key={channel.id}
            to={`https://www.twitch.tv/${channel.display_name}`}
            rel='noopener noreferrer'
            target='_blank'
          >
            <img src={channel.profile_image_url} alt={channel.display_name} />
            <h3>{channel.display_name}</h3>
          </Link>
        ))}
      </div>
			<div className='title-wrapper'>
        <h3 className='title'><i className="bi bi-twitch"></i> Bei uns streamen</h3>
        <hr />
      </div>
			<div className='become-streamer-wrapper'>
				<div className='clip-wrapper'>
					<img src={nexark_preview2} alt="" />
				</div>
				<ul className='info-list'>
					<li>Kann ich bei euch spielen und streamen?</li>
					<ul>
						<li>Ja. Grundsätzlich kann das jeder.</li>
						<li>Um auf unserer Homepage promoted zu werden tritt mit uns in Kontakt.</li>
					</ul>
					<li>Was muss ich tun wenn ich promoted wurde?</li>
					<ul>
						<li>Dein Twitch Kanal wird generell bei uns verlinkt.</li>
						<li>Um in den Livebereich geschaltet zu werden musst du in der richtigen Kategorie sein (ARK: Survival Ascended) und unseren Cluster Namen (NEXARK) im Titel unterbringen.</li>
					</ul>
				</ul>
			</div>
    </div>
  );
};

export default Livepage;
